angular.module('app').directive('adminTimeInput', function() {
    return {
        require: ['ngModel', '?^mdInputContainer'],
        restrict: 'A',
        link: function (scope, elem, attrs, controllers) {
            var ngModel = controllers[0];
            var inputContainer = controllers[1];
            var toView = function (val) {
                if(inputContainer) {
                    inputContainer.setHasValue(!ngModel.$isEmpty(val));
                }
                if(!val) {
                    return val;
                }

                return moment(val, ['h:m:s', 'h:m']).format('HH:mm');
            };

            ngModel.$formatters = [toView];

            // Native time inputs display empty time segments, so keep their labels floated.
            if(inputContainer) {
                inputContainer.setHasPlaceholder(true);
            }

            // Remove Angular's parsers https://docs.angularjs.org/api/ng/input/input%5Btime%5D.
            ngModel.$parsers = [];
        }
    };
});
